// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-d57f47055a04/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-d57f47055a04/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._b-0 {\n  transition: font-size, color, font-weight;\n  transition-duration: 200ms;\n  transition-timing-function: ease-in-out;\n}\n", ""]);
// Exports
export var text = "_b-0";
export default ___CSS_LOADER_EXPORT___;
